import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_align_middle.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconAlignMiddle = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconAlignMiddle;
